import { COMPLETE_MEDIA_UPLOAD, CREATE_MEDIA_UPLOAD } from './apollo-queries';
import { clientPromise } from './apollo.config';
import axios from 'axios';
import { Buffer } from 'buffer';

const uploadImageToS3Url = (imageFile: string, url: string) => {
  const bufferdata = Buffer.from(imageFile.split(',')[1], 'base64');

  return axios({
    method: 'put',
    url,
    data: bufferdata,
    headers: { 'Content-Type': 'image/png', 'Content-Encoding': 'base64' },
  });
};

export const uploadProfileAvatar = async (
  fileName: string,
  imageFile: any,
  refId: string | null
) => {
  return new Promise(async (resolve, reject) => {
    const mediaUploadResult = await (
      await clientPromise
    ).mutate({
      mutation: CREATE_MEDIA_UPLOAD,
      variables: {
        filename: fileName,
        mediaType: 'PROFILE',
        refId: refId,
      },
    });
    await uploadImageToS3Url(
      imageFile,
      mediaUploadResult.data.createMediaUpload.uploadUrl
    );
    const completeResult = await (
      await clientPromise
    ).mutate({
      mutation: COMPLETE_MEDIA_UPLOAD,
      variables: {
        mediaId: mediaUploadResult.data.createMediaUpload.id,
      },
    });
    resolve(completeResult);
  });
};
